import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { TransportManagementProfileListFacade } from './transport-management-profile-list.facade';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class TransportManagementProfileListGuard {
  constructor(private transportPlannerProfileListFacade: TransportManagementProfileListFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.transportPlannerProfileListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.transportPlannerProfileListFacade);
  }
}
